import { Timestamp } from "firebase/firestore";

export function formatTimestampNoTime(
  timestamp: Timestamp | Date | undefined | null
): string {
  if (!timestamp) {
    return "N/A";
  }

  if (timestamp instanceof Date) {
    return timestamp.toLocaleDateString();
  }

  if ("seconds" in timestamp && "nanoseconds" in timestamp) {
    return new Date(
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000
    ).toLocaleDateString();
  }

  return "Invalid date";
}

export function formatTimestamp(
  timestamp: Timestamp | Date | undefined | null
): string {
  if (!timestamp) {
    return "N/A";
  }

  if (timestamp instanceof Date) {
    return timestamp.toLocaleString();
  }

  if ("seconds" in timestamp && "nanoseconds" in timestamp) {
    return new Date(
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000
    ).toLocaleString();
  }

  return "Invalid date";
}
